import http from '@/http/aisea/axios'
import moment from 'moment-timezone';
const resource = "/enterprises/crews/timesheet/records";

export default {
  search(payload) {
    payload.now = moment().local().format('YYYY-MM-DD');
    return http.get(`${resource}`, {
      params: payload
    });    
  },
};
